// Sub-grab handler.
//
// 2026-05-18 rewrite: replace the N-per-sub query pattern with a single
// FOC-collection walk, then do all matching client-side. Two reasons:
//
// 1. Case-insensitivity. The old code did `productMetafield: {value: <sub>}`
//    which is EXACT-MATCH. Customers' sub records carry mixed casing from
//    Locke's flsksvr.tech era ("Uncanny X-Men" + "UNCANNY X-MEN" duplicates,
//    "Wonder Woman" subs against "WONDER WOMAN" product metafields, etc.).
//    Anchor: 2026-05-18 umustbcrazee@yahoo.com — has 134 subs but only 2
//    were pulling (the two whose case happened to match the metafield).
//    Client-side matching against the full FOC catalog uses normalized
//    keys, so all 119+ case-mismatched subs now match too.
//
// 2. Speed. The old code fired one Storefront query per sub (134 subs
//    × ~3-4 queries each for series/writer/artist/cover_artist =
//    400-600 round trips), often blowing past the 30s watchdog and
//    leaving the customer with a partial cart and "Try Again" button.
//    Single-walk + 2-3 paginated requests finishes in <2s.
$(document).ready(function () {

  $('.grab-btn').click(async function () {
    console.time('subgrabber');
    var grabBtn = document.getElementById('grab-btn');

    grabBtn.classList.remove('hover');
    grabBtn.classList.add('disAbled');
    grabBtn.setAttribute('disabled', true);

    var dots = window.setInterval(function () {
      if (grabBtn.textContent.length > 14) grabBtn.textContent = 'Please Wait';
      else grabBtn.textContent += '.';
    }, 100);

    // 2026-04-26 watchdog: hard 30s ALWAYS-clears-spinner timer.
    // Re-armable: the item-by-item add fallback (see addItems) legitimately
    // needs longer than 30s, so it extends the budget rather than letting
    // the watchdog reset the UI out from under an in-flight recovery.
    var watchdog = null;
    function armWatchdog(ms) {
      try { clearTimeout(watchdog); } catch (e) { }
      watchdog = window.setTimeout(function () {
        console.warn('[subgrabber] watchdog fired — flow exceeded ' + ms + 'ms, resetting UI');
        try { clearInterval(dots); } catch (e) { }
        grabBtn.textContent = 'Try Again';
        grabBtn.removeAttribute('disabled');
        grabBtn.classList.remove('disAbled');
      }, ms);
    }
    armWatchdog(30000);

    try {
      // 1) Load cart so we don't double-add what's already in it.
      const cartData = await fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); });
      const cartVariantIds = new Set((cartData.items || []).map(function (it) { return Number(it.id); }));

      // 1b) Books the customer already ordered, so a re-click on a later Sunday
      //     doesn't re-add something they own (0626IM0465 was re-bought three
      //     times). FAILS OPEN: if the lookup can't run or can't be trusted, the
      //     grab proceeds exactly as before and the customer is told the check
      //     was skipped. Manual add-to-cart is untouched, so a deliberate second
      //     copy is always still possible.
      const orderedVariantIds = new Set();
      const skippedOrdered = new Set();
      let orderCheckFailed = false;
      let orderCheckPartial = false;
      try {
        const custId = grabBtn.getAttribute('data-id');
        const custEmail = grabBtn.getAttribute('data-email');
        if (!custId || !custEmail) throw new Error('no customer id/email on button');
        const ctrl = new AbortController();
        const abortTimer = window.setTimeout(function () { ctrl.abort(); }, 10000);
        try {
          const r = await fetch('https://ecgce-backend.uzairkhan.workers.dev/api/storefront/get-ordered-variants', {
            method: 'post',
            credentials: 'omit',
            cache: 'no-cache',
            headers: new Headers({ 'content-type': 'application/json' }),
            body: JSON.stringify({ custEmail: custEmail, customerID: custId }),
            signal: ctrl.signal,
          });
          if (!r.ok) throw new Error('get-ordered-variants ' + r.status);
          const data = await r.json();
          if (!data || !Array.isArray(data.variantIds)) throw new Error('malformed response');
          for (const v of data.variantIds) {
            const n = Number(v);
            if (n) orderedVariantIds.add(n);
          }
          // Keep what came back, but say the list may be short.
          if (data.truncated && (data.truncated.orders || data.truncated.lineItems)) orderCheckPartial = true;
        } finally {
          clearTimeout(abortTimer);
        }
      } catch (e) {
        console.warn('[subgrabber] past-order check failed, grabbing without it:', e);
        orderCheckFailed = true;
        orderCheckPartial = false;
        orderedVariantIds.clear();
      }

      // What the customer is told about the check, appended to whichever
      // message ends the flow.
      function orderNote() {
        const parts = [];
        if (skippedOrdered.size > 0) parts.push('Skipped ' + skippedOrdered.size + " you've already ordered.");
        if (orderCheckFailed) parts.push("Couldn't check your past orders, so books you already bought may be included.");
        else if (orderCheckPartial) parts.push("Couldn't check all of your past orders, so some books you already bought may be included.");
        return parts.join(' ');
      }
      function withNote(text) {
        const note = orderNote();
        return note ? text + '. ' + note : text;
      }

      // 2) Parse the customer's sub lists from the button's data attributes
      //    (populated by main-cart-items.liquid's getSubs() call to
      //    /api/subscriptions/list).
      const seriesRaw = grabBtn.getAttribute('data-series') || '[]';
      const creRaw = grabBtn.getAttribute('data-cre-series') || '[]';
      let seriesSubs = [];
      let creSubs = [];
      try { seriesSubs = JSON.parse(seriesRaw); } catch (e) { /* malformed — skip */ }
      try { creSubs = JSON.parse(creRaw); } catch (e) { /* malformed — skip */ }
      if (!Array.isArray(seriesSubs)) seriesSubs = [];
      if (!Array.isArray(creSubs)) creSubs = [];

      // 3) UI settings: noVars (skip variant covers for series subs) and
      //    cvrArtsOnly (skip writer/artist matches, only cover-artist).
      const cvrSetting = document.getElementById('cvrSetting');
      const cvrArtSetting = document.getElementById('cvrArtSetting');
      const noVars = !!(cvrSetting && cvrSetting.checked);
      const covArtsOnly = !!(cvrArtSetting && cvrArtSetting.checked);

      // 4) Pull every product in the FOC collection with its match
      //    metafields. Paginated because Storefront caps `first` at 250
      //    and the collection can grow past that.
      const allProducts = await fetchAllFocProducts();

      // 5) Build lowercase-keyed maps for case-insensitive lookup.
      const seriesMap = new Map();
      const writerMap = new Map();
      const artistMap = new Map();
      const covArtMap = new Map();
      for (const p of allProducts) {
        addToMap(seriesMap, p.series, p);
        for (const w of p.writers) addToMap(writerMap, w, p);
        for (const a of p.artists) addToMap(artistMap, a, p);
        for (const c of p.coverArtists) addToMap(covArtMap, c, p);
      }

      // 6) Walk the customer's subs, accumulating items to add.
      const allItems = [];
      const queuedVids = new Set();

      function tryAdd(product, restrict) {
        const vid = product.variantId;
        if (!vid || cartVariantIds.has(vid) || queuedVids.has(vid)) return;
        // For series subs with noVars checked, skip variant covers
        // (Cover B/C/D/...). The series-default is Cover A only.
        if (restrict === 'noVars' && product.isVar) return;
        // For writer/artist matches, only add Cover A. Empty var_desig
        // is also OK (legacy products that pre-date var_desig).
        if (restrict === 'coverAOnly' && product.varDesig && product.varDesig !== 'A') return;
        // Already bought on an earlier order: leave it for a deliberate add.
        if (orderedVariantIds.has(vid)) { skippedOrdered.add(vid); return; }
        allItems.push({ id: vid, quantity: 1 });
        queuedVids.add(vid);
      }

      for (const sub of seriesSubs) {
        const key = normalize(sub);
        if (!key) continue;
        for (const p of (seriesMap.get(key) || [])) tryAdd(p, noVars ? 'noVars' : null);
      }

      if (!covArtsOnly) {
        for (const sub of creSubs) {
          const key = normalize(sub);
          if (!key) continue;
          for (const p of (writerMap.get(key) || [])) tryAdd(p, 'coverAOnly');
          for (const p of (artistMap.get(key) || [])) tryAdd(p, 'coverAOnly');
        }
      }
      // Cover artists always grab — the customer subbed to a cover
      // artist BECAUSE they want all the covers that artist drew.
      for (const sub of creSubs) {
        const key = normalize(sub);
        if (!key) continue;
        for (const p of (covArtMap.get(key) || [])) tryAdd(p, null);
      }

      console.log('[subgrabber] matched', allItems.length, 'items across',
        seriesSubs.length, 'series +', creSubs.length, 'creators',
        '(catalog size:', allProducts.length, ')');

      // 7) Send the batch add. If empty, surface a friendly message.
      if (allItems.length === 0) {
        clearInterval(dots);
        clearTimeout(watchdog);
        grabBtn.textContent = withNote('No Items Found');
        return;
      }

      // cart/add.js is ATOMIC: if any one line is unpurchasable (sold out,
      // unpublished, or delisted mid-flight by the FOC cutoff sweep) Shopify
      // rejects the whole request with 422 and adds NOTHING. addItems bisects
      // any chunk that is genuinely rejected so one bad line can't drop the
      // other N-1 — and, since 2026-08-27, never bisects a throttle or a
      // full cart, because subdividing neither of those can help.
      const result = await addItems(allItems, function () { armWatchdog(180000); });

      clearInterval(dots);
      clearTimeout(watchdog);
      console.timeEnd('subgrabber');

      if (result.added === 0) {
        console.error('[subgrabber] nothing added; failed variant ids:', result.failed,
          'throttled:', result.throttled);
        // "Busy — Try Again" invited an immediate re-click, and an immediate
        // re-click is exactly what keeps the Cloudflare wall up. Ask for a wait.
        grabBtn.textContent = withNote(result.throttled
          ? 'Store Is Verifying — Wait A Minute, Then Retry'
          : result.cartFull
            ? 'Cart Is Full — Please Check Out First'
            : 'Add Failed — Try Again');
        grabBtn.removeAttribute('disabled');
        grabBtn.classList.remove('disAbled');
        return;
      }

      // Only books Shopify actually refused are called unavailable. A throttled
      // run is incomplete, not a verdict — tell the customer to click again
      // (the cart.js filter on the next run skips what already landed).
      if (result.cartFull) {
        // Waiting will not clear this one — the cart is the problem, so say so
        // instead of blaming the books or asking for a pointless retry.
        grabBtn.textContent = withNote('Added ' + result.added +
          ' — cart is full, please check out before grabbing the rest');
        grabBtn.removeAttribute('disabled');
        grabBtn.classList.remove('disAbled');
        return;
      }

      if (result.throttled) {
        // Do NOT reload here. The wall is up right now, so a reload serves the
        // "Verifying your connection..." page — which is the interstitial the
        // 2026-08-27 reporter hit right after their partial grab.
        grabBtn.textContent = withNote('Added ' + result.added +
          ' so far — wait a minute, then click again for the rest');
        grabBtn.removeAttribute('disabled');
        grabBtn.classList.remove('disAbled');
        return;
      }

      const finalNote = orderNote();
      grabBtn.textContent = 'Added ' + result.added +
        (result.failed.length ? ' (' + result.failed.length + ' unavailable)' : '') +
        '. ' + (finalNote ? finalNote + ' ' : '') + 'Reloading…';
      // Long enough to read the note before the reload replaces it.
      await delay(finalNote ? 4000 : 1500);
      location.reload();

    } catch (err) {
      console.error('[subgrabber] failed:', err);
      try { clearInterval(dots); } catch (e) { }
      try { clearTimeout(watchdog); } catch (e) { }
      grabBtn.textContent = 'Try Again';
      grabBtn.removeAttribute('disabled');
      grabBtn.classList.remove('disAbled');
    }
  });

});

function delay(time) {
  return new Promise(function (r) { setTimeout(r, time); });
}

// Outcome of one cart/add.js POST.
//   OK        — Shopify took the whole batch.
//   REJECTED  — Shopify refused it (422). Something in these items is bad.
//   THROTTLED — rate limit / bot challenge / 5xx. Says NOTHING about the
//               items; treating it as REJECTED would libel good books as
//               "unavailable", which is exactly what the first cut of this
//               fix did (2026-08-07: 69 live books reported unavailable).
const ADD_OK = 'ok';
const ADD_REJECTED = 'rejected';
const ADD_THROTTLED = 'throttled';
// CART_FULL — the store's own cart-validation Shopify Function raised a runtime
// error, and Shopify fails that CLOSED, refusing the whole add with a 422.
// Discovered 2026-08-27: a fresh cart takes 65 lines fine and refuses at 80,
// and growing a cart 40 lines at a time refuses on the second chunk. The 422
// body is the giveaway:
//   {"status":422,"message":"A runtime error occurred while running the
//    validation.", ...}
// It is a 422, but it is emphatically NOT a verdict on the items — every book
// in that batch is live and purchasable on its own. Letting it reach bisectAdd
// would walk it down to singletons and then report ~every remaining book
// "unavailable", which is exactly the libel the 2026-08-07 fix exists to
// prevent. So it gets its own outcome, and it stops the run rather than
// retrying: unlike a throttle, waiting does not help, because the cart is
// still the same size a minute later.
const ADD_CART_FULL = 'cart_full';

// The pre-2026-08-07 code chained .then(r => r.json()) with a bare .catch(),
// which only fires on network errors — a 422 resolved normally, so the UI
// reported "Added N" for a cart that never changed.
async function postAdd(items) {
  try {
    const r = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    });
    if (r.ok) return ADD_OK;
    const body = await r.text().catch(function () { return ''; });
    console.warn('[subgrabber] cart/add ' + r.status + ':', body.slice(0, 120));
    // Match on the message, not the status: this arrives as a 422, the same
    // status an unpurchasable line uses.
    if (body.indexOf('running the validation') !== -1) return ADD_CART_FULL;
    // Cloudflare's bot wall answers with `cf-mitigated: challenge` and an HTML
    // "Verifying your connection..." page — 429 here, 403 in other tenants. It
    // is a wall, not a verdict on the items, so it must read as THROTTLED.
    // Same-origin request, so the header is readable.
    if (r.headers.get('cf-mitigated')) return ADD_THROTTLED;
    return (r.status === 429 || r.status === 403 || r.status >= 500)
      ? ADD_THROTTLED : ADD_REJECTED;
  } catch (e) {
    console.error('[subgrabber] cart/add failed:', e);
    return ADD_THROTTLED;
  }
}

// Recovery-path POST: paced so the burst doesn't trip Shopify's AJAX rate
// limiter (which answers with a Cloudflare "Verifying your connection..."
// challenge), with exponential backoff when it trips anyway.
//
// The backoff used to total ~6s (400/800/1600/3200). Measured 2026-08-27
// against the live store: once the wall trips it stays up for MINUTES — a
// 5-item add was still challenged 120s later. A 6s budget never outlives it,
// so every attempt burned was another request feeding the same wall.
const ADD_BACKOFF_MS = [400, 2000, 6000, 15000];
async function postAddPaced(items) {
  for (let attempt = 0; attempt < ADD_BACKOFF_MS.length; attempt++) {
    await delay(ADD_BACKOFF_MS[attempt]);
    const res = await postAdd(items);
    if (res !== ADD_THROTTLED) return res;
  }
  return ADD_THROTTLED;
}

// Binary-search the rejected batch for the bad line(s). ~2·log2(N) requests
// instead of N — for 75 items that's ~14 POSTs rather than 75, which both
// finishes in seconds and stays under the rate limiter. Every half that
// still adds cleanly goes in as one batch, so good books are never held
// hostage by a neighbour.
async function bisectAdd(items) {
  if (items.length === 1) {
    const res = await postAddPaced(items);
    if (res === ADD_OK) return { added: 1, failed: [], throttled: false };
    if (res === ADD_THROTTLED) return { added: 0, failed: [], throttled: true };
    if (res === ADD_CART_FULL) return { added: 0, failed: [], throttled: false, cartFull: true };
    return { added: 0, failed: [items[0].id], throttled: false };
  }

  const mid = Math.floor(items.length / 2);
  const halves = [items.slice(0, mid), items.slice(mid)];
  const out = { added: 0, failed: [], throttled: false, cartFull: false };

  for (const half of halves) {
    const res = await postAddPaced(half);
    if (res === ADD_OK) { out.added += half.length; continue; }
    if (res === ADD_THROTTLED) { out.throttled = true; break; }
    // Splitting further cannot help — the cart is already too big for the
    // validation function, so every subdivision refuses too.
    if (res === ADD_CART_FULL) { out.cartFull = true; break; }
    const sub = await bisectAdd(half);
    out.added += sub.added;
    out.failed = out.failed.concat(sub.failed);
    if (sub.throttled) { out.throttled = true; break; }
    if (sub.cartFull) { out.cartFull = true; break; }
  }
  return out;
}

// cart/add.js is ATOMIC — one unpurchasable line makes Shopify 422 the whole
// request and add NOTHING. Only a rejected chunk pays for the bisect that
// isolates the offending line.
// Anchor: 2026-08-07 umustbcrazee@yahoo.com — 75-item grab, 422, cart
// unchanged, button still said "Added 75. Reloading…".
//
// 2026-08-27, same reporter: "grabs maybe the first half ... then asks to
// verify", and every click after that says "Busy — Try Again".
//
// The cause was ADD_CART_FULL above: the cart-validation Function crashed once
// the CART passed ~65-80 lines, and Shopify fails that CLOSED with a 422. The
// old addItems only tested for ADD_OK, so that 422 fell into bisectAdd — the
// path for a genuinely unpurchasable line. Bisecting cannot converge on a
// cart-size ceiling (the batch shrinks, the cart does not), so it walked all
// the way down firing a POST at every step. THAT storm of rapid requests is
// what tripped Cloudflare's bot wall and produced the "Verifying your
// connection..." page the customer saw, and the sticky challenge behind every
// later click.
//
// A CORRECTION, because the first cut of this fix got it wrong. It chunked to
// 40 lines on the belief that one large request tripped the bot wall by SIZE.
// That reading came from firing 10/50/100/130-line requests back to back in
// one script, so the later 429s were the earlier requests' rate catching up.
// Re-measured properly — one request, fresh session, nothing else nearby — a
// single 250-LINE add returns 200 OK. The wall is driven by request RATE and
// client reputation, not by the size of one request.
//
// So chunking small was solving a problem that does not exist, and made the
// real one worse: it turns one request into several, and rate is exactly what
// the wall counts. Chunk large. The loop stays as a bound for pathological
// carts and to report partial progress honestly, not as a wall-avoidance
// tactic.
//
// Two defects compounded it. (1) Nothing kept the first request under the wall.
// (2) The wall is a throttle, but addItems only tested for ADD_OK, so a walled
// batch fell through into bisectAdd — and bisecting a SIZE-triggered wall
// cannot converge: halving 130 lines gives 65, which is still over the ceiling,
// so the retries are themselves too big and each one re-arms the wall. The
// customer's own trace is that shape: ~100 matches -> walled; the first 50-line
// half slips through (50 is under the ceiling) -> "grabs maybe the first half";
// the second half is walled again -> partial result -> location.reload() lands
// on the challenge page -> "asks to verify"; and every later click repeats it
// -> "Busy — Try Again".
//
// Fix: chunk below the measured line ceiling so the happy path never trips the
// wall, and bisect ONLY a genuine 422.
// 250 is measured: a single 250-line add returns 200 from a clean session.
// Bigger is untested, not known-bad. Every real grab is one request at this
// size, which is the point — fewer requests is strictly better against a
// rate-driven wall.
const ADD_CHUNK_SIZE = 250;
const CHUNK_PACE_MS = 600;   // only reached by carts above 250 matched books

async function addItems(items, onFallback) {
  const chunks = [];
  for (let i = 0; i < items.length; i += ADD_CHUNK_SIZE) {
    chunks.push(items.slice(i, i + ADD_CHUNK_SIZE));
  }

  // Extend the watchdog for EVERY run, not just multi-chunk ones: one chunk
  // that keeps getting walled burns the full backoff ladder (~23s of sleeping
  // plus four round trips), which races the 30s watchdog and would reset the
  // button out from under a flow that is still going.
  if (onFallback) onFallback();

  const out = { added: 0, failed: [], throttled: false, cartFull: false };
  for (let i = 0; i < chunks.length; i++) {
    const chunk = chunks[i];
    if (i > 0) await delay(CHUNK_PACE_MS);

    const res = await postAddPaced(chunk);
    if (res === ADD_OK) { out.added += chunk.length; continue; }

    // THROTTLED says nothing about the items. Bisecting here is what deepened
    // the wall before — stop, keep what landed, and let the customer retry.
    if (res === ADD_THROTTLED) { out.throttled = true; break; }

    // CART_FULL says nothing about the items either, and unlike a throttle it
    // will not pass on its own. Stop and report it as a cart-size problem.
    if (res === ADD_CART_FULL) { out.cartFull = true; break; }

    console.warn('[subgrabber] chunk rejected — bisecting', chunk.length, 'items');
    if (onFallback) onFallback();
    const sub = await bisectAdd(chunk);
    out.added += sub.added;
    out.failed = out.failed.concat(sub.failed);
    if (sub.throttled) { out.throttled = true; break; }
    if (sub.cartFull) { out.cartFull = true; break; }
  }

  console.log('[subgrabber] add finished:', out.added, 'added,',
    out.failed.length, 'rejected, throttled:', out.throttled,
    'cartFull:', out.cartFull, '(' + chunks.length + ' chunks)');
  return out;
}

function normalize(s) {
  if (typeof s !== 'string') return '';
  return s.trim().toLowerCase();
}

function addToMap(map, key, product) {
  const k = normalize(key);
  if (!k) return;
  if (!map.has(k)) map.set(k, []);
  map.get(k).push(product);
}

// Walk every product in /collections/foc with the metafields we need
// to match against series subs + creator subs. Paginated; ~200 products
// per page keeps the requested-cost under Storefront's per-request cap.
async function fetchAllFocProducts() {
  const products = [];
  let cursor = null;
  let hasNext = true;
  const PAGE_SIZE = 200;
  // Hard stop in case Shopify ever loops endCursor pathologically.
  let pages = 0;
  const MAX_PAGES = 10;

  while (hasNext && pages < MAX_PAGES) {
    pages++;
    const cursorClause = cursor ? `, after: "${cursor}"` : '';
    const query = `
      query {
        collectionByHandle(handle: "foc") {
          products(first: ${PAGE_SIZE}${cursorClause}) {
            pageInfo { hasNextPage endCursor }
            nodes {
              id
              variants(first: 1) { nodes { id } }
              series: metafield(key: "series", namespace: "custom") { value }
              writers: metafield(key: "writers", namespace: "custom") { value }
              artists: metafield(key: "artists", namespace: "custom") { value }
              coverArtists: metafield(key: "cover_artists", namespace: "custom") { value }
              isVar: metafield(key: "is_var", namespace: "custom") { value }
              varDesig: metafield(key: "var_desig", namespace: "custom") { value }
            }
          }
        }
      }
    `;
    const res = await fetch('https://ecgce.myshopify.com/api/2025-01/graphql.json', {
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': window.ECGCE_STOREFRONT_TOKEN,
        'Content-Type': 'application/graphql',
      },
      body: query,
    });
    const obj = await res.json();
    const coll = obj && obj.data && obj.data.collectionByHandle;
    if (!coll) break;
    const nodes = (coll.products && coll.products.nodes) || [];
    for (const n of nodes) {
      const variantGid = n.variants && n.variants.nodes && n.variants.nodes[0] && n.variants.nodes[0].id;
      // cart/add.js wants the numeric variant id (not the gid).
      const variantId = variantGid ? Number(variantGid.split('/').pop()) : null;
      products.push({
        id: n.id,
        variantId: variantId,
        series: n.series ? n.series.value : null,
        writers: parseListMf(n.writers),
        artists: parseListMf(n.artists),
        coverArtists: parseListMf(n.coverArtists),
        isVar: n.isVar && n.isVar.value === 'true',
        varDesig: n.varDesig ? n.varDesig.value : null,
      });
    }
    hasNext = !!(coll.products.pageInfo && coll.products.pageInfo.hasNextPage);
    cursor = coll.products.pageInfo && coll.products.pageInfo.endCursor;
  }

  return products;
}

// metafields of type list.single_line_text_field serialize as a JSON
// array string. Plain single_line_text_field metafields may also be
// CSV-ish. Be liberal in parsing; return [] on any error.
function parseListMf(mf) {
  if (!mf || !mf.value) return [];
  try {
    const parsed = JSON.parse(mf.value);
    if (Array.isArray(parsed)) return parsed.filter(function (s) { return typeof s === 'string'; });
  } catch (e) { /* not JSON — fall through */ }
  // Fallback: treat as comma-separated single string.
  return String(mf.value).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
}
